export default ['JsonRPCService', 'JobService', function (JsonRPCService, JobService) {

    return {
        findJobByJobNumber: function findJobByJobNumber(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'findJobByJobNumber', [renewalNumber]);
        },
        getRenewalSummary: function getRenewalSummary(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getJobSummaryCount', [renewalNumber]);
        },
        getNotesForRenewal: function getNotesForRenewal(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getNotesForRenewal', [renewalNumber]);
        },
        createNoteForRenewal: function createNoteForRenewal(renewalNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'createNoteForRenewal', [renewalNumber, noteDTO]);
        },
        getDocumentsForRenewal: function getDocumentsForRenewal(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getDocumentsForRenewal', [renewalNumber]);
        },
        referToUnderwriter: function referToUnderwriter(renewalNumber, noteBody) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'referToUnderwriter', [renewalNumber, noteBody]);
        },
        withdrawRenewalByRenewalNumber: function withdrawRenewalByRenewalNumber(renewalNumber) {
            return JobService.withdrawJobByJobNumber(renewalNumber);
        },
        markRenewalNotTaken: function markRenewalNotTaken(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'markRenewalNotTaken', [renewalNumber]);
        },
        markRenewalNonRenew: function markRenewalNonRenew(renewalNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'markRenewalNonRenew', [renewalNumber]);
        },
        updateCoveredEmployees: function updateCoveredEmployees(renewalNumber, portalcoveredEmployees, existingEmployees, subject, description) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'updateCoveredEmployees', [renewalNumber, portalcoveredEmployees, existingEmployees, subject, description]);
        },
        getAllClassCodes: function getAllClassCodes(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getAllClassCodes', [jobNumber]);
        },
        getClassCodeBycode: function getClassCodeBycode(code, jobNumber) {
            return JsonRPCService.send('pc', 'gateway/renewal', 'getClassCodeBycode', [code, jobNumber]);
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/RenewalService.js
// module id = 1794
// module chunks = 0